import {
  reduceNumEngagements, reduceNumHotProspects, useCampaignDeliveredTouchStats, useCampaignLeadResponseStats,
} from 'data/campaign-stats';
import React from 'react';

import { Box, Container } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import StatsEngagementsIcon from 'components/CustomIcons/stats/StatsEngagementsIcon';
import StatsHotProspectsIcon from 'components/CustomIcons/stats/StatsHotProspectsIcon';
import StatsPropertiesIcon from 'components/CustomIcons/stats/StatsPropertiesIcon';
import StatsTouchesSentIcon from 'components/CustomIcons/stats/StatsTouchesSentIcon';

import CampaignProgressGraph from './CampaignProgressGraph';
import StatCard from './StatCard';
import TouchAnalyticsGraph from './TouchAnalyticsGraph';
import TouchesSentBarGraph from './TouchesSentBarGraph';

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    overflowX: 'auto',
    overflowY: 'auto',
  },
  infoBubble: {
    maxWidth: '700px',
    margin: '40px auto 50px',
  },
}));

export interface Props {
  campaign: any;
  setActiveTab: (tab: string) => void;
}

export default ({ campaign, setActiveTab }: Props) => {
  const classes = useStyles();
  const theme = useTheme();

  const { deliveredTouchStats } = useCampaignDeliveredTouchStats(campaign._id);
  const { leadResponseStats } = useCampaignLeadResponseStats(campaign._id);

  const onViewProspects = () => setActiveTab('Prospects');
  const onViewHotProspects = () => setActiveTab('Stats - Hot Prospects');
  const onViewEngagements = () => setActiveTab('Stats - Engagements');
  const onViewTouchTimeline = () => setActiveTab('Touches');

  const touchesSentStat = React.useMemo<number | undefined>(() => {
    if (!deliveredTouchStats) return undefined;

    return deliveredTouchStats!.reduce((sum, current) => sum + current.count, 0);
  }, [deliveredTouchStats]);

  const hotProspectsStat = React.useMemo<number | undefined>(() => {
    if (!leadResponseStats) return undefined;

    return reduceNumHotProspects(leadResponseStats);
  }, [leadResponseStats]);

  const engagementsStat = React.useMemo<number | undefined>(() => {
    if (!leadResponseStats) return undefined;

    return reduceNumEngagements(leadResponseStats);
  }, [leadResponseStats]);

  // TODO: RESPONSIVENESS
  return (
    <Container maxWidth="xl">
      {/* // <GridContainer justifyContent="center" alignContent="center">
    //   <GridItem xs={12} sm={6} lg={3}> */}
      <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gridGap: 20,
        marginTop: 30,
        marginBottom: 26,
        [theme.breakpoints.down('md')]: {
          justifyContent: 'center',
        },
      }}
      >
        <StatCard
          title="Properties"
          stat={campaign.subscribedEvents.length}
          icon={<StatsPropertiesIcon />}
          onViewAllClick={onViewProspects}
        />
        {/* </GridItem>
      <GridItem xs={12} sm={6} lg={3}> */}
        <StatCard
          title={(
            <>
              Hot Prospects
              {' '}
              <span style={{ fontSize: 24 }}> 🔥</span>
            </>
          )}
          stat={hotProspectsStat}
          icon={<StatsHotProspectsIcon />}
          onViewAllClick={onViewHotProspects}
        />
        {/* </GridItem>
      <GridItem xs={12} sm={6} lg={3}> */}
        <StatCard
          title="Engagements"
          stat={engagementsStat}
          icon={<StatsEngagementsIcon />}
          onViewAllClick={onViewEngagements}
        />
        {/* </GridItem>
      <GridItem xs={12} sm={6} lg={3}> */}
        <StatCard
          title="Touches Sent"
          stat={touchesSentStat}
          icon={<StatsTouchesSentIcon />}
          onViewAllClick={onViewTouchTimeline}
        />
      </Box>
      {/* //   </GridItem>
  // </GridContainer> */}

      <Box sx={{ marginBottom: 26 }}>
        <TouchAnalyticsGraph campaignId={campaign._id} />
      </Box>

      <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gridGap: 20,
        [theme.breakpoints.down('md')]: {
          justifyContent: 'center',
        },
      }}
      >
        <CampaignProgressGraph
          campaignStartDate={campaign.campaignStartDate}
          campaignEndDate={campaign.campaignEndDate}
          onViewTouchTimeline={onViewTouchTimeline}
        />

        <TouchesSentBarGraph
          campaignId={campaign._id}
          onViewTouchTimeline={onViewTouchTimeline}
        />

        {/* <EmailDeliverabilityStats
          campaignId={campaign._id}
          onViewTouchTimeline={onViewTouchTimeline}
        /> */}
      </Box>
    </Container>
  );
};
